import * as Reopen from './Reopen';
import * as OpenAction from './OpenAction';
import * as Deliver from './Deliver';
import * as Complete from './Complete';

let reopenActions = {
  ...Complete,
  ...Deliver,
  ...OpenAction,
  ...Reopen
};

export default reopenActions;